import { openDB } from 'idb';
import { Title } from '../models/calculation';
import { SaveTitleParams } from '../models/params';

const dbPromise = openDB('calculator-db', 1, {
  upgrade(db) {
    db.createObjectStore('titles', { keyPath: 'id', autoIncrement: true });
  },
});

export const saveTitle = async ({
  title,
  path,
  principal,
  rate,
  period,
  finalAmount,
  totalInterest,
  currencySymbol, 

}: SaveTitleParams & { currencySymbol: string }): Promise<void> => {
  const db = await dbPromise;
  await db.add('titles',
     { title, path, principal, rate, period, finalAmount, totalInterest,currencySymbol });
};



export const fetchTitles = async (): Promise<Title[]> => {
  const db = await dbPromise;
  const allTitles: Title[] = await db.getAll('titles');
  return allTitles;
};

export const updateTitle = async (id: number, updatedData: Omit<Title, 'id'>): Promise<void> => {
  const db = await dbPromise;
  await db.put('titles', { id, ...updatedData });
};


export const deleteTitle = async (id: number): Promise<void> => {
  const db = await dbPromise;
  await db.delete('titles', id); 
};


